import { SVGProps, Ref, forwardRef } from 'react';

export const SendIosFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12m11.9-2.33v7.83h-1.8V9.67l-2.964 2.963-1.272-1.273 4.5-4.5.636-.636.636.636 4.5 4.5-1.272 1.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendIosFilledSize24Glyph.displayName = 'SendIosFilledSize24Glyph';
